import { Component, OnInit, ViewChild } from '@angular/core';
import { Materia } from '../models/materia';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { MateriaService } from '../services/materia.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import swal from 'sweetalert2';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-materia',
  templateUrl: './materia.component.html',
  styleUrls: ['./materia.component.scss']
})
export class MateriaComponent implements OnInit {
  materiasFiltradas: Materia[] = [];
  filtroTitulo: string;
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  thumb = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private router: Router,
    private materiaService: MateriaService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private utilitarioService: UtilitarioService,
    private route: ActivatedRoute,
    private paginatorService: PaginatorService
  ) {
    this.route.data.subscribe(data => {
      this.thumb = data['thumb'];
      this.thumb = this.thumb ? this.thumb : false;
    });
  }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    this.buscarMaterias();
  }

  abrirUrl(url) {
    if(!url) return;

    window.open(url, '_blank');
  }

  novaMateria() {
    this.router.navigate([this.thumb ? 'configuracoes/noticias-economia/novo' : 'configuracoes/materia/novo']);
  }

  editarMateria(materia: Materia) {
    this.router.navigate([this.thumb ? 'configuracoes/noticias-economia/editar' : 'configuracoes/materia/editar', materia.id]);
  }

  excluirMateria(materia: Materia) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a ' + (this.thumb ? 'Notícia?' : 'Matéria?'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirMateria');
        this.materiaService.excluir(materia.id).subscribe(resp => {
          this.notificacaoService.sucesso('Matéria excluída com sucesso!!!');
          this.carregandoService.esconde('excluirMateria');
          this.buscarMaterias();
        }, (erro) => {
          this.carregandoService.esconde('excluirMateria');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  buscarMaterias() {
    this.carregandoService.mostra('buscaMaterias');

    this.materiaService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.filtroTitulo, this.thumb).subscribe(dados => {
      this.materiasFiltradas = dados.itens;
      this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;
      this.carregandoService.esconde('buscaMaterias');
    }, (erro) => {
      this.carregandoService.esconde('buscaMaterias');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarMaterias();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  filtrar() {
    this.buscarMaterias();
    this.paginator.firstPage();
  }
}